<template>
  <div class="contact">
    <div class="contact__btn contact__btn-customer" @click="handleCustomerServiceClick">
      <div>
        <img :src="require('@/assets/images/icon-headphone-white.svg')" />
      </div>
      <div>在线客服</div>
    </div>

    <div class="contact__btn-phone">
      <a class="contact__btn" href="tel:0571-85785223" @click="handlePhoneClick">
        <div>
          <img :src="require('@/assets/images/icon-phone-white.svg')" />
        </div>
        <div>销售热线</div>
      </a>
      <div class="phone-number">0571-85785223</div>
    </div>
    <div class="contact__btn-phone">
      <a class="contact__btn" href="tel:400-0878-198" @click="handlePhoneClick">
        <div>
          <img :src="require('@/assets/images/icon-phone-white.svg')" />
        </div>
        <div>售后服务</div>
      </a>
      <div class="phone-number">400-0878-198</div>
    </div>

    <BackToTop />
  </div>
</template>

<script>
import qiyuMixin from '../mixins/qiyu.js'

export default {
  mixins: [qiyuMixin],
  components: {
    BackToTop: () => import('./BackToTop.vue'),
  },
  mounted() {
    this.addQiyuScript()
  },
  props: {
    landingPageName: {
      type: String,
      default: '',
    },
  },
  methods: {
    handlePhoneClick() {
      // TODO:
      if (this.landingPageName === 'esignPropagate') {
        window.meteor && window.meteor.track && window.meteor.track('phone', { convert_id: '1655142884209676' })
      }
      this.$tsignData.track('sign_olandingpage_phonecallconsult')
      this.$tsignData.track('click_phone_call')
    },
  },
}
</script>

<style lang="less" scoped>
.contact /deep/ .back-to-top {
  position: relative;
  bottom: 0;
  right: 0;
  overflow: hidden;
  display: inline-block;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
}
.contact {
  display: block;
  position: fixed;
  bottom: 50%;
  right: 0;
  transform: translateY(50%);
  z-index: 9990;
  width: 80px;
  text-align: right;

  &__btn {
    flex-shrink: 0;
    display: inline-block;
    width: 60px;
    height: 40px;
    background-color: #e61717;
    color: #fff;
    font-size: 12px;
    padding: 10px 0;
    text-align: center;
    margin-bottom: 1px;
    border-radius: 4px 0 0 4px;
    cursor: pointer;
    box-sizing: content-box;

    &-customer {
      padding-right: 0;
      transition: padding 200ms;

      &:hover {
        padding-right: 20px;
      }
    }
    img {
      height: 26px;
      width: 26px;
      margin: 0 auto;
    }
  }

  &__btn-phone {
    display: flex;
    width: 400px;
    margin-left: 20px;
    transition: margin 200ms;

    .phone-number {
      font-size: 20px;
      line-height: 60px;
      height: 60px;
      color: #fff;
      background-color: #e61717;
      padding-right: 10px;
    }

    &:hover {
      margin-left: -140px;
    }
  }
}
</style>
